import { MutableRefObject, useRef } from 'react';

import { FormsAuthAPIServiceTypes } from '../../services/FormsAuthServices/APIService';
import { FormsAuthAPIService } from '../../services/FormsAuthServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

const useFormsAuthAPIService = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();
  const FormsAuthAPIRef: MutableRefObject<FormsAuthAPIServiceTypes | null> =
    useRef(null);

  if (FormsAuthAPIRef.current === null) {
    FormsAuthAPIRef.current = new FormsAuthAPIService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    formsAuthAPIService: FormsAuthAPIRef.current
  };
};

export { useFormsAuthAPIService };
